import React from 'react';
import { arrayOf, object, string, bool, oneOf } from 'prop-types';
import { Popover } from '@fiverr-private/fit';
import { MP_NOTABLE_CLIENTS_INTERACTION } from '../../../../utils/mixPanelEvents';
import { BQ_NOTABLE_CLIENT_HOVERED } from '../../../../utils/bigQueryEvents';
import ClientLogo from '../ClientLogo';
import DetailsPopover from '../DetailsPopover';
import { getClientLogoPath } from '../helper';
import './style.scss';

const ClientList = ({
    displayClients = [],
    sellerName,
    profilePhoto,
    logoSize,
    showIndustry = false,
    mixPanelParams,
    oddsPopoverPositionLeft = false,
    source
}, { biEvents }) => {
    const reportClientHoverEvent = (client, index) => {
        biEvents.sendBigQueryEvent({
            eventName: BQ_NOTABLE_CLIENT_HOVERED,
            params: {
                clientData: { ...client },
                source,
                index
            }
        });
        biEvents.sendMixPanelEvent({
            eventName: MP_NOTABLE_CLIENTS_INTERACTION,
            params: { ...mixPanelParams, 'client name' : client?.name }
        });
    };

    return (
        <>
            { displayClients.map((client, index) => {
                const { name, industry } = client.enriched_details;
                const logoPath = getClientLogoPath(client);
                const logoProps = {
                    logoPath,
                    name,
                    size: logoSize
                };
                const popoverProps = {
                    sellerName, profilePhoto, client
                };
                const popoverPosition = (index === 0) || (oddsPopoverPositionLeft && index % 2 === 0) ?
                    Popover.POSITIONS.BOTTOM_LEFT :
                    Popover.POSITIONS.BOTTOM;

                return (
                    <li key={client.website} style={{ '--animation-order': index }}>
                        <Popover className="notable-clients-popover specific-z-index"
                            contentClassName="notable-client"
                            trigger={Popover.TRIGGERS.HOVER}
                            position={popoverPosition}
                            allowOverflow={true}
                            content={<DetailsPopover {...popoverProps}/>}
                            onOpen={() => reportClientHoverEvent(client, biEvents, index + 1)}>
                            <div className="logo-wrap">
                                <ClientLogo {...logoProps}/>
                            </div>
                            <div className="client-details">
                                <span className="client-name">{name}</span>
                                { showIndustry && <span className="industry">{industry}</span> }
                            </div>
                        </Popover>
                    </li>
                );
            })}
        </>
    );
};

ClientList.propTypes = {
    displayClients: arrayOf(object),
    sellerName: string,
    profilePhoto: string,
    logoSize: oneOf(Object.values(ClientLogo.SIZES)),
    showIndustry: bool,
    oddsPopoverPositionLeft: bool
};

ClientList.contextTypes = {
    biEvents: object
};

ClientList.SOURCES = {
    BELOW_THE_FOLD: 'below the fold',
    ABOVE_THE_FOLD: 'above the fold'
};

export default ClientList;
